export default function() {
  const widgetName = 'cardWidgetAds';
  const widgetOpts = cardWidgetAdsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName}`).addClass('swiper-container');
      $(`#${widgetName} .card-widget-item`).addClass('swiper-slide');
      $(`#${widgetName} .card-widget-item`).wrapAll('<div class="swiper-wrapper"></div>');
      $(`#${widgetName}`).append(`
        <div class="${widgetName}-button-prev"></div>
        <div class="${widgetName}-button-next"></div>
      `);

      const cardWidgetAdsSlider = new Swiper(`#${widgetName}.swiper-container`, {
        speed: 800,
        autoplay: {
          delay: 5000,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,
        autoHeight: true,     
        loop: true,
        effect: 'slide',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: `.${widgetName}-button-next`,
          prevEl: `.${widgetName}-button-prev`,
        }
      });

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 0,
      navText: ['',''],
      nav: true
    },
    textOverImage: true
  });

}